import type { DatasourcesStatusOutputV1 } from '@/sdk/model/DatasourcesStatusOutputV1';
import { flux } from '@/core/flux.module';

export function setDatasources(datasources: DatasourcesStatusOutputV1) {
  flux.dispatch('DATASOURCES_SET_DATASOURCES', { datasources });
}
